import { Button } from '@etg/wings';
import { css } from '@eti/styles';
import { CaretDown } from '@phosphor-icons/react';
import type { ReactNode } from 'react';
import { useToggle } from '../../../common/custom-hooks/toggle';

const buttonContainerStyles = css`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

const expandContentWrapperStyles = css`
  background-color: inherit;
`;

const caretStyles = (isOpen: boolean) => css`
  transform: rotateX(${isOpen ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;
`;

interface ExpandContentProps {
  buttonDataTestId: string;
  children: (props: { isExpanded: boolean }) => ReactNode;
  label: string;
  labelHide: string;
}

const ExpandContent = ({ children, label, labelHide, buttonDataTestId }: ExpandContentProps) => {
  const { isOpen: isExpanded, handleToggle } = useToggle();

  return (
    <div className={expandContentWrapperStyles}>
      {children({ isExpanded })}
      <div className={buttonContainerStyles}>
        <Button
          data-testid={`${buttonDataTestId}-button`}
          iconSuffix={<CaretDown className={caretStyles(isExpanded)} />}
          onClick={handleToggle}
          size="small"
        >
          {isExpanded ? labelHide : label}
        </Button>
      </div>
    </div>
  );
};

export default ExpandContent;
